import React from 'react';
import Icon from '../Icon';
import clsx from 'clsx';
import { useTypedSelector } from '../../Hooks/useTypedSelector';

interface LanguageSelectTriggerProps {
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  languageSelectActive: boolean;
}

const LanguageSelectTrigger = ({
  onClick,
  languageSelectActive,
}: LanguageSelectTriggerProps) => {
  const { currentChannel } = useTypedSelector(
    (state) => state.channelPicker
  );
  const { currency } = useTypedSelector((state) => state.cart);

  return (
    <button
      onClick={onClick}
      className="mr-2 flex items-center bg-transparent py-3 text-sm uppercase text-gray-700 group-[.is-light-theme]:text-white lg:pr-3"
    >
      <span className="whitespace-nowrap">
        {currentChannel.name} ({currency})
      </span>
      <Icon
        className={clsx(
          languageSelectActive ? 'rotate-180' : 'rotate-0',
          'ml-0.5 h-3 w-3 transition-transform duration-300'
        )}
        name="chevron-down"
      />
    </button>
  );
};

export default LanguageSelectTrigger;
